import React from 'react';
import { Greet, UserSimple } from '~/types/models';
import { Paginator, PaginationMetadata } from '~/react-hooks/usePagination';
import { DOMRectReadOnly } from 'use-measure';
import Workspace from '../Workspaces/Types/Workspace';

export interface TasklistSortOrder {
  [userId: string]: string | undefined;
}

interface PaginationObject<E> {
  data: E[];
  paginator: Paginator<E>;
  metadata: PaginationMetadata;
}

export interface TodoListContext {
  greets: PaginationObject<Greet>;

  greetIds: string[];

  users: PaginationObject<UserSimple>;

  assignee: Record<string, UserSimple | null>;
  setAssignee(assignees?: Record<string, UserSimple | null>): void;

  sortOrder: TasklistSortOrder | null;
  setSortOrder(sortOrder: TasklistSortOrder | null): void;

  // eslint-disable-next-line
  bulkSelect: any;
  selectedGreets: Greet[];

  showFallback: boolean;

  selectedWorkspace?: Workspace | null;

  container: DOMRectReadOnly;
}

export default React.createContext<TodoListContext>(
  {} as unknown as TodoListContext
);
